import { BuxDocument } from "@bux/document/mod.mts";

class DocumentSheet extends BuxDocument {}

new DocumentSheet();

import "./DocumentSheet.mcss";
